import React from 'react';
import { MRT_Row } from '@talentmesh/table';
import { CandidateRowEntry } from '@/Models/CandidateRowEntry';
import { SmallBadge } from '@/Components/shadcn';
import UIStrings from '@/Utils/UIStrings';

interface CandidateRowEntryInternalBenchmarkBadgeProps {
    row: MRT_Row<CandidateRowEntry>;
}

const CandidateRowEntryInternalBenchmarkBadge = ({
    row,
}: CandidateRowEntryInternalBenchmarkBadgeProps): React.JSX.Element | undefined => {
    const candidate = row.original;

    if (!candidate.isInternal) {
        return undefined;
    }

    return (
        candidate.isInternal && (
            <SmallBadge variant="default" className="text-center">
                {UIStrings.InternalBenchmark}
            </SmallBadge>
        )
    );
};

export default CandidateRowEntryInternalBenchmarkBadge;
